import { FC, ReactNode, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { OrganizationState } from '@/types/organizations'
import { useAuth } from '../../context/Auth'
import ProtectedRoutePopUps from './ProtectedRoutePopUps'

type ProtectedRouteParams = {
  children: ReactNode
  redirectTo?: string
  enabled?: boolean
  enableArchive?: boolean
}

const ProtectedRoute: FC<ProtectedRouteParams> = ({
  children,
  redirectTo = '/sign-in',
  enabled = true,
  enableArchive = false,
}) => {
  const { user, isLoading, organizationState, isError } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading) {
      if (isError || !enabled) {
        navigate(redirectTo)
      }
      if (organizationState === OrganizationState.archived && !enableArchive) {
        navigate('/archived-organization')
      }
    }
  }, [user, isLoading, enabled, isError])

  if (isLoading || !user) return null

  return (
    <>
      <ProtectedRoutePopUps user={user} />
      {enabled ? children : null}
    </>
  )
}

export default ProtectedRoute
